import { Directive, HostListener } from '@angular/core';
@Directive({
  standalone: false,
  selector: '[ngxClickStopPropagation]'
})
export class StopPropagationDirective {
  @HostListener('click', ['$event']) onClick(event: any): void {
    event.stopPropagation();
  }
}
